import { render, staticRenderFns } from "./OpenApi.vue?vue&type=template&id=5468bc2b&"
import script from "./OpenApi.vue?vue&type=script&lang=js&"
export * from "./OpenApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports